import imageUrlBuilder from '@sanity/image-url';
import axios from 'axios';
import sanity from '@sanity/client';
export const configureSanityClient = (config) => {
    return sanity({
        projectId: config.SANITY_PROJECT_ID,
        dataset: config.SANITY_DATASET,
        apiVersion: '2021-08-31',
        useCdn: false
    });
};
// ---------- FUNCTIONS ----------
export const refId = (doc) => {
    if (doc._ref) {
        return doc._ref;
    }
    else if (doc._ref) {
        return doc._id;
    }
    else {
        return undefined;
    }
};
export const sanityFetch = async (config, query) => {
    try {
        const url = `https://${config.SANITY_PROJECT_ID}.api.sanity.io/v1/data/query/${config.SANITY_DATASET}?query=` +
            encodeURIComponent(query);
        const res = await axios.get(url);
        return res.data.result;
    }
    catch (error) {
        console.log('Fetch error', error);
        return undefined;
    }
};
export const getImageUrl = (sanityClient, image, width, height, pixelRatio = 1, orientation = 0, fit = 'max') => {
    if (!image || !image.asset) {
        return '';
    }
    let builder = imageUrlBuilder(sanityClient).image(image);
    if (width) {
        builder = builder.width(Math.floor(width * pixelRatio));
    }
    if (height) {
        builder = builder.height(Math.floor(height * pixelRatio));
    }
    if (orientation) {
        builder = builder.orientation(orientation);
    }
    if (fit) {
        builder = builder.fit(fit);
    }
    return builder.url();
};
// ---------- QUERIES ----------
export const assetQuery = `{
  asset->,
  ...
}`;
//# sourceMappingURL=sanity.js.map